define([
	"dojo/_base/declare",
	"csi/action/NewController",
	"csi/table/NewMixin"
], function(declare,NewController,NewMixin) {

	return declare([NewController, NewMixin], {
		preProcess: function() {
			// summary: call mixin before continuing
			if (this._newPreProcess()) {
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// summary: call mixin if no action-specific post processing
			return this.inherited(arguments) || this._newPostProcess(true); 
		}
	});
});